export default {"src":"/_next/static/media/create_account_phone.c7a16c2e.svg","height":211,"width":250};